import React, { useEffect, useMemo, useRef, useState } from "react";
import { Menu } from "antd";
import { useSelector } from "react-redux";
import {
  getOrgDetails,
  getOrgSettings,
  getUserOrgDetails,
} from "../../thunks/user-management";
import { trnTypes, userOrgRoles } from "../../constants";
import { addAppTab, useMouseTrap } from "../../utils";
import { AppstoreOutlined, FormOutlined, BarChartOutlined, SettingOutlined, ProductOutlined } from '@ant-design/icons';
import { getSettingRecordDetails, getSettings } from "../../thunks/settings";

export const getMuenuItems = (industry) => {
  const rawSectionName = industry === "Textile" ? "Grey" : industry === "Weaving" ? "Yarn" : "Raw";
  return {
    MASTER__ACCOUNT: { title: "Accounts", path: "/master/account" },
    MASTER__ACCOUNT_GROUP: { title: "Account Groups", path: "/master/account-group" },
    MASTER__PRODUCT__PRODUCT: { title: "Product", path: "/master/product/product" },
    MASTER__PRODUCT__PRODUCT_GROUP: { title: "Product Group", path: "/master/product/product-group" },
    MASTER__PRODUCT__PRODUCT_SCREEN: { title: "Item", path: "/master/product/product-screen" },
    MASTER__PRODUCT__SUB_DESIGN: { title: "Sub Design", path: "/master/product/sub-design" },
    MASTER__PRODUCT__BRAND: { title: "Brand", path: "/master/product/brand" },
    MASTER__PRODUCT__RATE_CATEGORY: { title: "Rate Category", path: "/master/product/rate-category" },
    MASTER__PRODUCT__UNIT: { title: "Unit Master", path: "/master/product/unit" },
    MASTER__PRODUCT__PACKING_MASTER: { title: "Packing Master", path: "/master/product/packing-master" },
    MASTER__PRODUCT__HSN_MASTER: { title: "HSN Master", path: "/master/product/hsn-master" },
    MASTER__PRODUCT__JOB_TYPE: { title: "Job Type", path: "/master/product/job-type" },
    MASTER__OTHER__FIRM: { title: "Firm", path: "/master/other-master/firm" },
    MASTER__OTHER__TAX: { title: "Tax", path: "/master/other-master/tax" },
    MASTER__OTHER__BANK: { title: "Bank", path: "/master/other-master/bank" },
    MASTER__OTHER__MARKET: { title: "MARKET", path: "/master/other-master/market" },
    MASTER__OTHER__PARTY_GROUP: { title: "Party Group", path: "/master/other-master/party-group" },
    MASTER__OTHER__SALESPERSON: { title: "Sales Person", path: "/master/other-master/salesperson" },
    MASTER__OTHER__CONTACT: { title: "Contact", path: "/master/other-master/contact" },
    MASTER__OTHER__REMARK: { title: "Remark", path: "/master/other-master/remark" },
    TRNS__AGENCY__PURCHASE: { title: "Agency Purchase", path: `/transaction/${trnTypes.AGENCY_PURCHASE}` },
    TRNS__AGENCY__PURCHASE_ORDER: { title: "Agency Purchase Order", path: `/transaction/${trnTypes.AGENCY_PURCHASE_ORDER}` },
    TRNS__AGENCY__PURCHASE_RETURN: { title: "Agency Purchase Return", path: `/transaction/${trnTypes.AGENCY_PURCHASE_RETURN}` },
    TRNS__AGENCY__PAYMENT: { title: "Agency Payment", path: `/transaction/${trnTypes.AGENCY_PAYMENT}` },
    TRNS__AGENCY__CHEQUE_RETURN: { title: "Agency Cheque Return Entry", path: `/transaction/${trnTypes.AGENCY_CHEQUE_RETURN_ENTRY}` },
    TRNS__AGENCY__DISPATCH_LETTER: { title: "Agency Dispatch Letter", path: `/agency/agency-dispatch-letter` },
    TRNS__SAL__SALES: { title: "Sales", path: `/transaction/${trnTypes.SALES}` },
    TRNS__SAL__SALES_ORDER: { title: "Sales Order", path: `/transaction/${trnTypes.SALES_ORDER}` },
    TRNS__SAL__SALES_CHALLAN: { title: "Sales Challan", path: `/transaction/${trnTypes.SALES_CHALLAN}` },
    TRNS__SAL__SALES_RETURN_CHALLAN: { title: "Sales Return Challan", path: `/transaction/${trnTypes.SALES_RETURN_CHALLAN}` },
    TRNS__SAL__SALES_RETURN: { title: "Sales Return", path: `/transaction/${trnTypes.SALES_RETURN}` },
    TRNS__SAL__EXCESS_SALES_RETURN: { title: "Excess RG", path: `/transaction/${trnTypes.EXCESS_SALES_RETURN}` },
    TRNS__SAL__CREDIT_NOTE: { title: "Sales Credit Note", path: `/transaction/${trnTypes.SALES_CREDIT_NOTE}` },
    TRNS__SAL__DEBIT_NOTE: { title: "Sales Debit Note", path: `/transaction/${trnTypes.SALES_DEBIT_NOTE}` },
    TRNS__SAL__QUICK_SALES: { title: "Quick Sales", path: `/transaction/${trnTypes.QUICK_SALES}` },
    TRNS__PUR__PURCHASE: { title: "Purchase", path: `/transaction/${trnTypes.PURCHASE}` },
    TRNS__PUR__GENERAL_PURCHASE: { title: "General Purchase", path: `/transaction/${trnTypes.GENERAL_PURCHASE}` },
    TRNS__PUR__PURCHASE_ORDER: { title: "Purchase Order", path: `/transaction/${trnTypes.PURCHASE_ORDER}` },
    TRNS__PUR__PURCHASE_CHALLAN: { title: "Purchase Challan", path: `/transaction/${trnTypes.PURCHASE_CHALLAN}` },
    TRNS__PUR__PURCHASE_RETURN_CHALLAN: { title: "Purchase Return Challan", path: `/transaction/${trnTypes.PURCHASE_RETURN_CHALLAN}` },
    TRNS__PUR__PURCHASE_RETURN: { title: "Purchase Return", path: `/transaction/${trnTypes.PURCHASE_RETURN}` },
    TRNS__PUR__CREDIT_NOTE: { title: "Purchase Credit Note", path: `/transaction/${trnTypes.PURCHASE_CREDIT_NOTE}` },
    TRNS__PUR__DEBIT_NOTE: { title: "Purchase Debit Note", path: `/transaction/${trnTypes.PURCHASE_DEBIT_NOTE}` },
    TRNS__PUR__QUICK_PURCHASE: { title: "Quick Purchase", path: `/transaction/${trnTypes.QUICK_PURCHASE}` },
    TRNS__PAYMENTS__RECEIPT: { title: "Receipt Entry", path: `/transaction/${trnTypes.RECEIPT_ENTRY}` },
    TRNS__PAYMENTS__PAYMENT: { title: "Payment Entry", path: `/transaction/${trnTypes.PAYMENT_ENTRY}` },
    TRNS__PAYMENTS__CHEQUE_RETURN: { title: "Cheque Return Entry", path: `/transaction/${trnTypes.CHEQUE_RETURN_ENTRY}` },
    TRNS__PAYMENTS__MULTI_RECEIPT: { title: "Multi Receipt", path: `/transaction/other/multi-entry`, state: { trnType: trnTypes.RECEIPT_ENTRY } },
    TRNS__PAYMENTS__MULTI_PAYMENT: { title: "Multi Payment", path: `/transaction/other/multi-entry`, state: { trnType: trnTypes.PAYMENT_ENTRY } },
    TRNS__JOURNAL__JOURNAL: { title: "Journal Entry", path: `/transaction/${trnTypes.JOURNAL_ENTRY}` },
    TRNS__JOURNAL__CONTRA: { title: "Credit Transfer Entry", path: `/transaction/${trnTypes.CONTRA_ENTRY}` },
    TRNS__JOURNAL__MULTI_JOURNAL: { title: "Multi Journal", path: `/transaction/other/multi-entry`, state: { trnType: trnTypes.JOURNAL_ENTRY } },
    TRNS__MILL__ISSUE: { title: "Mill Issue", path: `/transaction/${trnTypes.MILL_ISSUE}` },
    TRNS__MILL__RECEIVE: { title: "Mill Receive", path: `/transaction/${trnTypes.MILL_RECEIVE}` },
    TRNS__MILL__CUTTING: { title: "Lump Cutting", path: `/transaction/${trnTypes.CUTTING}` },
    TRNS__JOBWORK__ISSUE: { title: "Job Issue", path: `/transaction/${trnTypes.JOB_WORK_ISSUE}` },
    TRNS__JOBWORK__RECEIVE_CHALLAN: { title: "Job Receive", path: `/transaction/${trnTypes.JOB_WORK_RECEIVE_CHALLAN}` },
    TRNS__JOBWORK__RECEIVE: { title: "Job Bill", path: `/transaction/${trnTypes.JOB_WORK_RECEIVE}` },
    TRNS__JOBWORK__INWARD: { title: "Job Inward", path: `/transaction/${trnTypes.JOB_WORK_INWARD}` },
    TRNS__JOBWORK__OUTWARD: { title: "Job Outward", path: `/transaction/${trnTypes.JOB_WORK_OUTWARD}` },
    TRNS__STK__INWARD: { title: "Stock Inward", path: `/transaction/${trnTypes.STOCK_INWARD_ENTRY}` },
    TRNS__STK__OUTWARD: { title: "Stock Outward", path: `/transaction/${trnTypes.STOCK_OUTWARD_ENTRY}` },
    TRNS__STK__ASSEMBLY: { title: "Stock Assembly", path: `/transaction/${trnTypes.STOCK_ASSEMBLY_ENTRY}` },
    TRNS__STK__MOVEMENT: { title: "Stock Movement", path: `/transaction/${trnTypes.STOCK_MOVEMENT_ENTRY}` },
    TRNS__PENDING__LR: { title: "Pending LR", path: `/pending/lr` },
    TRNS__PENDING__LOTNO: { title: "Pending Lotno", path: `/pending/lotno` },
    TRNS__PENDING__EINVOICES: { title: "Pending E-Invoices", path: `/pending/einvoices` },
    TRNS__PENDING__EWAYBILLS: { title: "Pending E-Way Bills", path: `/pending/ewaybills` },
    TRNS__PENDING__SERIES: { title: "Missing Series", path: `/pending/series` },
    TRNS__PENDING__AMT_RECON: { title: "Pending Amt Recon List", path: `/pending/amt-recon` },
    TRNS__OTHER__AUTO_STOCK_MOVEMENT: { title: "Auto Stock Movement Entry", path: `/transaction/other/auto-stock-movement` },
    TRNS__OTHER__COMM_STATUS: { title: "Commission Status Entry", path: `/transaction/other/comm-status` },
    TRNS__COURIER__ENTRY: { title: "Courier Dispatch", path: `/transaction/${trnTypes.COURIER}` },
    TRNS__COURIER__BULK_ENTRY: { title: "Courier Bulk Dispatch", path: `/transaction/courier/bulk-dispatch` },
    TRNS__OTHER__MULTI_ENTRY: { title: "Multi Entry", path: `/transaction/other/multi-entry` },
    REPORTS__AGENCY__DISPATCH: { title: "Dispatch", path: "/reports/agency/dispatch" },
    REPORTS__AGENCY__PAYMENT: { title: "Agency Payment Report", path: "/reports/agency/payment" },
    REPORTS__AGENCY__OUTSTANDING: { title: "Agency Outstanding Report", path: "/reports/agency/outstanding" },
    REPORTS__AGENCY__COMMISSION: { title: "Agency Commission Report", path: "/reports/agency/commission" },
    REPORTS__AGENCY__ORDER: { title: "Order Report", path: "/reports/agency/order" },
    REPORTS__AGENCY__PURCHASE: { title: "Agency Purchase Report", path: "/reports/agency/purchase" },
    REPORTS__AGENCY__UNBILLED_VOUCHERS: { title: "Unbilled Vouchers", path: "/reports/agency/unbilled-vouchers" },
    REPORTS__AGENCY__ANALYSIS: { title: "Agency Analysis", path: "/reports/transactions/analysis", state: { isAgency: true } },
    REPORTS__TRN__ANALYSIS: { title: "Transaction Analysis", path: "/reports/transactions/analysis" },
    REPORTS__TRN__REGISTER: { title: "Transaction Register", path: "/reports/transactions/all/register" },
    REPORTS__TRN__SUMMARY: { title: "Transaction Summary", path: "/reports/transactions/all/summary" },
    REPORTS__UNBILLED_CHALLAN__SLC: { title: "Sale Challan Report", path: `/reports/unbilled-challans/${trnTypes.SALES_CHALLAN}` },
    REPORTS__UNBILLED_CHALLAN__RSLC: { title: "Sale Return Challan Report", path: `/reports/unbilled-challans/${trnTypes.SALES_RETURN_CHALLAN}` },
    REPORTS__UNBILLED_CHALLAN__PRC: { title: "Purchase Challan Report", path: `/reports/unbilled-challans/${trnTypes.PURCHASE_CHALLAN}` },
    REPORTS__UNBILLED_CHALLAN__RPUC: { title: "Purchase Return Challan Report", path: `/reports/unbilled-challans/${trnTypes.PURCHASE_RETURN_CHALLAN}` },
    REPORTS__ORDER__SLO: { title: "Sales Order Report", path: "/reports/orders/sales-order" },
    REPORTS__ORDER__PUO: { title: "Purchase Order Report", path: "/reports/orders/purchase-order" },
    REPORTS__SALES__REGISTER: { title: "Sales Invoice Register", path: "/reports/transactions/sales/register" },
    REPORTS__SALES__SUMMARY: { title: "Sales Invoice Summary", path: "/reports/transactions/sales/summary" },
    REPORTS__SALES_RETURN__REGISTER: { title: "Sales Return Register", path: "/reports/transactions/sales-return/register" },
    REPORTS__SALES_RETURN__SUMMARY: { title: "Sales Return Summary", path: "/reports/transactions/sales-return/summary" },
    REPORTS__SALES_CREDIT_NOTE__REGISTER: { title: "Sales Credit Note Register", path: "/reports/transactions/sales-credit-note/register" },
    REPORTS__SALES_CREDIT_NOTE__SUMMARY: { title: "Sales Credit Note Summary", path: "/reports/transactions/sales-credit-note/summary" },
    REPORTS__SALES_DEBIT_NOTE__REGISTER: { title: "Sales Debit Note Register", path: "/reports/transactions/sales-debit-note/register" },
    REPORTS__SALES_DEBIT_NOTE__SUMMARY: { title: "Sales Debit Note Summary", path: "/reports/transactions/sales-debit-note/summary" },
    REPORTS__NET_SALES__REGISTER: { title: "Net Sales Register", path: "/reports/transactions/net-sales/register" },
    REPORTS__NET_SALES__SUMMARY: { title: "Net Sales Summary", path: "/reports/transactions/net-sales/summary" },
    REPORTS__PURCHASE__REGISTER: { title: "Purchase Invoice Register", path: "/reports/transactions/purchase/register" },
    REPORTS__PURCHASE__SUMMARY: { title: "Purchase Invoice Summary", path: "/reports/transactions/purchase/summary" },
    REPORTS__PURCHASE_RETURN__REGISTER: { title: "Purchase Return Register", path: "/reports/transactions/purchase-return/register" },
    REPORTS__PURCHASE_RETURN__SUMMARY: { title: "Purchase Return Summary", path: "/reports/transactions/purchase-return/summary" },
    REPORTS__PURCHASE_CREDIT_NOTE__REGISTER: { title: "Purchase Credit Note Register", path: "/reports/transactions/purchase-credit-note/register" },
    REPORTS__PURCHASE_CREDIT_NOTE__SUMMARY: { title: "Purchase Credit Note Summary", path: "/reports/transactions/purchase-credit-note/summary" },
    REPORTS__PURCHASE_DEDIT_NOTE__REGISTER: { title: "Purchase Debit Note Register", path: "/reports/transactions/purchase-debit-note/register" },
    REPORTS__PURCHASE_DEDIT_NOTE__SUMMARY: { title: "Purchase Debit Note Summary", path: "/reports/transactions/purchase-debit-note/summary" },
    REPORTS__NET_PURCHASE__REGISTER: { title: "Net Purchase Register", path: "/reports/transactions/net-purchase/register" },
    REPORTS__NET_PURCHASE__SUMMARY: { title: "Net Purchase Summary", path: "/reports/transactions/net-purchase/summary" },
    REPORTS__OUTSTANDING__SAL: { title: "Sales Outstanding", path: "/reports/outstanding/sales" },
    REPORTS__OUTSTANDING__PUR: { title: "Purchase Outstanding", path: "/reports/outstanding/purchase" },
    REPORTS__OUTSTANDING_90DAYS__SAL: { title: "Receivable 90 Days", path: "/reports/outstanding-90days/sales" },
    REPORTS__OUTSTANDING_90DAYS__PUR: { title: "Payable 90 Days", path: "/reports/outstanding-90days/purchase" },
    REPORTS__BROKERAGE__SAL: { title: "Sales Brokerage", path: "/reports/outstanding/brokerage/sales" },
    REPORTS__BROKERAGE__PUR: { title: "Purchase Brokerage", path: "/reports/outstanding/brokerage/purchase" },
    REPORTS__BANK__SLIP: { title: "Bank Slip", path: "/reports/bank/slip" },
    REPORTS__BANK__RECON: { title: "Bank Reco", path: "/reports/bank/recon" },
    REPORTS__BANK__AUTO_BRS: { title: "Auto Bank Reco", path: "/reports/bank/auto-brs" },
    REPORTS__BANK__INTEREST: { title: "Bank CC/OD Interest", path: "/reports/bank/interest" },
    REPORTS__BANK__STATEMENT: { title: "Bank Statement", path: "/reports/ledger/bank-statement" },
    REPORTS__LEDGER__LEDGER: { title: "Account Ledger", path: "/reports/ledger/ledger" },
    REPORTS__LEDGER__MULTI_LEDGER: { title: "Multi Ledger", path: "/reports/ledger/multi-ledger" },
    REPORTS__ACCOUNT_GROUP__BALANCE: { title: "Account Group Balance", path: "/reports/ledger/account-group-balance" },
    REPORTS__LEDGER_INTEREST: { title: "Ledger Interest Report", path: "/reports/ledger/ledger-interest" },
    REPORTS__TRNS_INTEREST: { title: "Payment Interest Register", path: "/reports/interest" },
    REPORTS__DEPRECIATION: { title: "Depreciation Report", path: "/reports/depreciation" },
    REPORTS__LEDGER_OUTSTANDING_MISMATCH: { title: "Ledger Outstanding Mismatch", path: "/reports/ledger-outstanding-mismatch" },
    REPORTS__ACCOUNT__BALANCE: { title: "Account Balance", path: "/reports/ledger/account-balance" },
    STK_REPORTS__MILL__PENDING: { title: "Mill Pending", path: "/reports/mill/grey-at-mill" },
    STK_REPORTS__MILL__RECEIVE: { title: "Mill Receive", path: "/reports/mill/mill-receive" },
    STK_REPORTS__MILL__SHORTAGE: { title: "Mill Shortage", path: "/reports/mill/shortage" },
    STK_REPORTS__RAW_AT_SHOP: { title: `${rawSectionName} At Shop`, path: "/reports/mill/grey-at-shop" },
    STK_REPORTS__FINISH_AT_SHOP: { title: "Finish At Shop", path: "/reports/job/finish-at-shop" },
    STK_REPORTS__JOB__JOB_AT_OUT: { title: "Job Out Pending", path: "/reports/job/job-at-out" },
    STK_REPORTS__JOB__JOB_RECEIVE: { title: "Job Receive", path: "/reports/job/job-receive" },
    STK_REPORTS__JOB__INWARD_WITH_MOVEMENT: { title: "Inward With Movement", path: "/reports/job/inward-with-movement" },
    STK_REPORTS__JOB__JOB_AT_IN: { title: "Job In Pending", path: "/reports/job/job-at-in" },
    STK_REPORTS__JOB__JOB_OUTWARD: { title: "Job Outward", path: "/reports/job/job-outward" },
    STK_REPORTS__SUMMARY: { title: "Stock Summary", path: "/reports/inventory/stock-summary" },
    STK_REPORTS__BALANCE: { title: "Stock Balance", path: "/reports/inventory/stock-balance" },
    REPORTS__GSTR__1: { title: "GSTR 1", path: "/reports/gstr/gstr1" },
    REPORTS__GSTR__2A: { title: "GSTR 2A", path: "/reports/gstr/gstr2a" },
    REPORTS__GSTR__2B: { title: "GSTR 2B", path: "/reports/gstr/gstr2b" },
    REPORTS__GSTR__3B: { title: "GSTR 3B", path: "/reports/gstr/gstr3b" },
    REPORTS__GSTR__9: { title: "GSTR 9", path: "/reports/gstr/gstr9" },
    REPORTS__TDS__SUMMARY: { title: "TDS Summary", path: "/reports/tds-tcs/tds-summary" },
    REPORTS__TDS__REGISTER: { title: "TDS Register", path: "/reports/tds-tcs/tds-register" },
    REPORTS__TCS__SUMMARY: { title: "TCS Summary", path: "/reports/tds-tcs/tcs-summary" },
    REPORTS__TCS__REGISTER: { title: "TCS Register", path: "/reports/tds-tcs/tcs-register" },
    REPORTS__TDS__94Q: { title: "94Q Report", path: "/reports/tds-tcs/tds-94q" },
    REPORTS__TDS__CREATE_CHALLAN: { title: "Pending TDS/TCS Challan", path: "/reports/tds-tcs/create-challan" },
    REPORTS__TDS__CHALLAN_HISTORY: { title: "TDS/TCS Challan History", path: "/reports/tds-tcs/challan-history" },
    REPORTS__TDS__RETURN_FILING: { title: "TDS/TCS Return Filing", path: "/reports/tds-tcs/return-filing" },
    REPORTS__FINAL__TRIAL_BALANCE: { title: "Trial Balance", path: "/reports/final-reports/TRIAL_BALANCE" },
    REPORTS__FINAL__TRIAL_BALANCE_OPENING: { title: "Trial Balance (Opening)", path: "/reports/final-reports/TRIAL_BALANCE?isOpening=true" },
    REPORTS__FINAL__BALANCE_SHEET: { title: "Balance Sheet", path: "/reports/final-reports/BALANCE_SHEET" },
    REPORTS__FINAL__PNL: { title: "Trading and P & L Account", path: "/reports/final-reports/TRADING_PNL" },
    REPORTS__FINAL__FINAL_LEDGER: { title: "Final Ledger", path: "/reports/ledger/final-ledger" },
    REPORTS__AUDIT__ANNEXURE44: { title: "Annexure 44", path: "/reports/audit/annexure44" },
    REPORTS__AUDIT__GP_STOCK_ANALYSIS: { title: "GP Stock Analysis", path: "/reports/audit/gp-stock-analysis" },
    REPORTS__AUDIT__AUDIT_LOG: { title: "Audit Log", path: "/reports/audit/audit-log" },
    REPORTS__AUDIT__USER_PERMISSIONS: { title: "User Permissions", path: "/reports/audit/user-permissions" },
    SETTINGS__PROFILE: { title: "Profile", path: "/settings/profile" },
    SETTINGS__FCYEARS: { title: "FC Years", path: "/settings/years" },
    SETTINGS__BACKUP: { title: "Backup", path: "/settings/backup" },
    SETTINGS__USERS: { title: "Users", path: "/settings/users" },
    SETTINGS__IMPORT__ACM: { title: "Import Accounts", path: "/settings/opening/import-accounts" },
    SETTINGS__IMPORT__BALANCES: { title: "Import Account Balances", path: "/settings/opening/import-account-balances" },
    SETTINGS__IMPORT__UPDATE_BALANCES: { title: "Opening Balances", path: "/settings/opening/update-account-balances" },
    SETTINGS__IMPORT__ITM: { title: "Import Products", path: "/settings/opening/import-items" },
    SETTINGS__IMPORT__ITS: { title: "Import Designs", path: "/settings/opening/import-item-screens" },
    SETTINGS__IMPORT__HSN: { title: "Import HSN Codes", path: "/settings/opening/import-hsn-codes" },
    SETTINGS__IMPORT__STK: { title: "Opening Stock", path: "/settings/opening/inventory" },
    SETTINGS__IMPORT__APUR: { title: "Opening Agency Purchase", path: `/settings/opening/agency-transaction/${trnTypes.AGENCY_PURCHASE}` },
    SETTINGS__IMPORT__ARPU: { title: "Opening Agency Return Goods", path: `/settings/opening/agency-transaction/${trnTypes.AGENCY_PURCHASE_RETURN}` },
    SETTINGS__IMPORT__APYM: { title: "Opening Agency Payments", path: `/settings/opening/agency-transaction/${trnTypes.AGENCY_PAYMENT}` },
    SETTINGS__IMPORT__QSAL: { title: "Opening Sales", path: `/settings/opening/transaction/${trnTypes.QUICK_SALES}` },
    SETTINGS__IMPORT__QPUR: { title: "Opening Purchase", path: `/settings/opening/transaction/${trnTypes.QUICK_PURCHASE}` },
    SETTINGS__IMPORT__GIS: { title: "Opening Mill Challans", path: `/settings/opening/transaction/${trnTypes.MILL_ISSUE}` },
    SETTINGS__IMPORT__JIS: { title: "Opening Job Challans", path: `/settings/opening/transaction/${trnTypes.JOB_WORK_ISSUE}` },
    SETTINGS__IMPORT__JIN: { title: "Opening Job Inward", path: `/settings/opening/transaction/${trnTypes.JOB_WORK_INWARD}` },
    SETTINGS__IMPORT__RSL: { title: "Opening Sales Return", path: `/settings/opening/transaction/${trnTypes.SALES_RETURN}` },
    SETTINGS__IMPORT__SCN: { title: "Opening Sales Credit Note", path: `/settings/opening/transaction/${trnTypes.SALES_CREDIT_NOTE}` },
    SETTINGS__IMPORT__SDN: { title: "Opening Sales Debit Note", path: `/settings/opening/transaction/${trnTypes.SALES_DEBIT_NOTE}` },
    SETTINGS__IMPORT__RCP: { title: "Opening Receipt", path: `/settings/opening/transaction/${trnTypes.RECEIPT_ENTRY}` },
    SETTINGS__IMPORT__RPU: { title: "Opening Purchase Return", path: `/settings/opening/transaction/${trnTypes.PURCHASE_RETURN}` },
    SETTINGS__IMPORT__PDN: { title: "Opening Purchase Debit Note", path: `/settings/opening/transaction/${trnTypes.PURCHASE_DEBIT_NOTE}` },
    SETTINGS__IMPORT__PCN: { title: "Opening Purchase Credit Note", path: `/settings/opening/transaction/${trnTypes.PURCHASE_CREDIT_NOTE}` },
    SETTINGS__IMPORT__PYM: { title: "Opening Payment", path: `/settings/opening/transaction/${trnTypes.PAYMENT_ENTRY}` },
    SETTINGS__IMPORT__BRCR: { title: "Bank Reconciliation Receipt", path: `/settings/opening/transaction/${trnTypes.BANK_RECONCILIATION_RECEIPT}` },
    SETTINGS__IMPORT__BRCP: { title: "Bank Reconciliation Payment", path: `/settings/opening/transaction/${trnTypes.BANK_RECONCILIATION_PAYMENT}` },
    SETTINGS__IMPORT__TRNS: { title: "Import Transactions", path: `/settings/import-transactions` },
    SETTINGS__IMPORT__UTILITIES__DATA_TRANSFER: { title: "Extract From Backup", path: `/settings/opening/data-transfer` },
    SETTINGS__IMPORT__UTILITIES__TEXT_TO_EXCEL: { title: "Text To Excel", path: `/settings/opening/text-to-excel` },
    SETTINGS__IMPORT__UTILITIES__TRANSFORM_OUTSTANDING: { title: "Transform Outstanding", path: `/settings/opening/transform-outstanding` },
    SETTINGS__SETUP__PREFERENCES: { title: "Preferences", path: "/settings/setup/preferences" },
    SETTINGS__SETUP__COSTING_EXPENSES: { title: "Costing Expenses", path: "/settings/setup/costing-expenses" },
    SETTINGS__SETUP__EXPENSES: { title: "Expenses", path: "/settings/setup/expenses" },
    SETTINGS__SETUP__DATA_ENTRY: { title: "Data Entry Setup", path: "/settings/setup/data-entry" },
    SETTINGS__SETUP__REPORT_FORMATS: { title: "Report Formats", path: "/settings/setup/report-formats" },
    SETTINGS__SETUP__CSV_EXPORT_FORMATS: { title: "CSV Export Formats", path: "/settings/setup/csv-export-formats" },
    SETTINGS__SETUP__CSV_IMPORT_FORMATS: { title: "CSV Import Formats", path: "/settings/setup/csv-import-formats" },
    SETTINGS__SETUP__VOUCHER_TEMPLATE: { title: "Voucher Template", path: "/settings/setup/voucher-template" },
    SETTINGS__SETUP__WHATSAPP: { title: "Whatsapp Integration", path: "/settings/setup/whatsapp" },
    SETTINGS__SETUP__EMAIL: { title: "Email Integration", path: "/settings/setup/email" },
    SETTINGS__SETUP__AUTOMATIONS: { title: "Automations", path: "/settings/setup/automations" },
    SETTINGS__SETUP__CUSTOM_FIELDS: { title: "Custom Fields", path: "/settings/setup/custom-fields" },
    SETTINGS__DATA_LOCKING: { title: "Data Locking", path: "/settings/data-locking" },
    SETTINGS__YEAREND: { title: "Year Ending", path: "/settings/year-closing-opening" },
    SETTINGS__UTILITIES__UPDATE_BROKER: { title: "Update Broker", path: "/settings/utils/update-broker" },
    SETTINGS__UTILITIES__UPDATE_CUT: { title: "Update cut", path: "/settings/utils/update-cut" },
    SETTINGS__UTILITIES__UPDATE_WASTAGE: { title: "Update wastage", path: "/settings/utils/update-wastage" },
    SETTINGS__UTILITIES__REINDEX_VOUCHERS: { title: "Re arrange vouchers", path: "/settings/utils/reindex-vouchers" },
    SETTINGS__UTILITIES__RESAVE_TRANSACTIONS: { title: "Resave transactions", path: "/settings/utils/resave-transactions" },
    SETTINGS__UTILITIES__MERGE_MASTERS: { title: "Merge masters", path: "/settings/utils/merge-masters" },
  }
};


export const useSideNavMenu = () => {
  const orgSettings = useSelector((state) => getOrgSettings(state));
  const modules = orgSettings.modules || {};
  const orgDetails = useSelector(state => getOrgDetails(state));
  const industry = orgDetails.industry;
  const menuItems = useMemo(() => getMuenuItems(industry), [industry]);
  const rawSectionName = industry === "Textile" ? "Grey" : industry === "Weaving" ? "Yarn" : "Raw";
  const userOrgDetails = useSelector(state => getUserOrgDetails(state));
  const userOrgRole = userOrgDetails.role;
  const userOrgPermissions = userOrgDetails.permissions || { masters: {}, transactions: {}, reports: {}, settings: {} };
  const reportPermissions = userOrgPermissions.reports || {};
  const salesOutstandingAccess = userOrgRole === userOrgRoles.OWNER || reportPermissions.salesOutstanding;
  const purchaseOutstandingAccess = userOrgRole === userOrgRoles.OWNER || reportPermissions.purchaseOutstanding;
  const salesBrokerageAccess = userOrgRole === userOrgRoles.OWNER || reportPermissions.salesBrokerage;
  const purchaseBrokerageAccess = userOrgRole === userOrgRoles.OWNER || reportPermissions.purchaseBrokerage;
  const salesOrderReportAccess = userOrgRole === userOrgRoles.OWNER || reportPermissions.salesOrder;
  const purchaseOrderReportAccess = userOrgRole === userOrgRoles.OWNER || reportPermissions.purchaseOrder;
  const acmFormSettings = useSelector(state => getSettingRecordDetails(state, "DATA_ENTRY", "ACM"));
  const customMasters = useSelector(state => getSettings(state).filter(obj => obj.type === "CUSTOM_FIELD" && obj.details.type === "CUSTOM_MASTER"));
  customMasters.forEach(obj => {
    menuItems[`MASTER__OTHER_MASTER__CF_${obj.id}`] = {
      title: obj.details.name,
      path: `/master/custom-master/${obj.id}`,
    }
  })

  const menuTree = [
    (userOrgRole === userOrgRoles.OWNER || userOrgPermissions.masters) && {
      key: "MASTER",
      label: "Master",
      icon: <AppstoreOutlined />,
      children: [
        { key: "MASTER__ACCOUNT", label: "Account" },
        { key: "MASTER__ACCOUNT_GROUP", label: "Account Group" },
        {
          key: "MASTER__PRODUCT",
          label: "Product",
          children: [
            { key: "MASTER__PRODUCT__PRODUCT", label: "Product" },
            { key: "MASTER__PRODUCT__PRODUCT_GROUP", label: "Product Group" },
            { key: "MASTER__PRODUCT__PRODUCT_SCREEN", label: "Design" },
            { key: "MASTER__PRODUCT__SUB_DESIGN", label: "Sub Design" },
            { key: "MASTER__PRODUCT__BRAND", label: "Brand" },
            { key: "MASTER__PRODUCT__RATE_CATEGORY", label: "Rate Category" },
            { key: "MASTER__PRODUCT__UNIT", label: "Unit" },
            { key: "MASTER__PRODUCT__HSN_MASTER", label: "HSN Code" },
            { key: "MASTER__PRODUCT__PACKING_MASTER", label: "Packing Type" },
            { key: "MASTER__PRODUCT__JOB_TYPE", label: "Job Type" },
          ]
        },
        {
          key: "MASTER__OTHER_MASTER",
          label: "Other Master",
          children: [
            { key: "MASTER__OTHER__FIRM", label: "Firm" },
            acmFormSettings?.enable_market ? { key: "MASTER__OTHER__MARKET", label: "Market" } : null,
            { key: "MASTER__OTHER__BANK", label: "Drawee Bank" },
            { key: "MASTER__OTHER__TAX", label: "Tax" },
            { key: "MASTER__OTHER__PARTY_GROUP", label: "Party Group" },
            { key: "MASTER__OTHER__CONTACT", label: "Contact" },
            { key: "MASTER__OTHER__SALESPERSON", label: "Sales Person" },
            { key: "MASTER__OTHER__REMARK", label: "Remark" },
            ...customMasters.map(obj => ({ key: `MASTER__OTHER_MASTER__CF_${obj.id}`, label: obj.details?.name }))
          ].filter(el => el)
        },
      ]
    },
    {
      key: "TRNS",
      label: "Transaction",
      icon: <FormOutlined />,
      children: [
        industry === "Agency" && {
          key: "TRNS__AGENCY",
          label: "Agency",
          children: [
            { key: "TRNS__AGENCY__PURCHASE", label: "Purchase" },
            { key: "TRNS__AGENCY__PURCHASE_ORDER", label: "Purchase Order" },
            { key: "TRNS__AGENCY__PURCHASE_RETURN", label: "Purchase Return" },
            { key: "TRNS__AGENCY__PAYMENT", label: "Payment" },
            { key: "TRNS__AGENCY__CHEQUE_RETURN", label: "Cheque Return" },
            { key: "TRNS__AGENCY__DISPATCH_LETTER", label: "Dispatch Letter" },
          ]
        },
        {
          key: "TRNS__SAL",
          label: "Sales",
          children: [
            { key: "TRNS__SAL__SALES_ORDER", label: "Order" },
            modules.salesChallan?.enabled ? { key: "TRNS__SAL__SALES_CHALLAN", label: "Challan" } : null,
            { key: "TRNS__SAL__SALES", label: "Invoice" },
            modules.salesReturnChallan?.enabled ? { key: "TRNS__SAL__SALES_RETURN_CHALLAN", label: "Return Goods Challan" } : null,
            { key: "TRNS__SAL__SALES_RETURN", label: "Return Goods" },
            { key: "TRNS__SAL__CREDIT_NOTE", label: "Credit Note" },
            { key: "TRNS__SAL__DEBIT_NOTE", label: "Debit Note" },
            modules.quickSales?.enabled ? { key: "TRNS__SAL__QUICK_SALES", label: "Quick Sale" } : null,
            modules.excessSalesReturn?.enabled ? { key: "TRNS__SAL__EXCESS_SALES_RETURN", label: "Excess RG" } : null,
          ].filter(v => v)
        },
        {
          key: "TRNS__PUR",
          label: "Purchase",
          children: [
            { key: "TRNS__PUR__PURCHASE_ORDER", label: "Order" },
            modules.purchaseChallan?.enabled ? { key: "TRNS__PUR__PURCHASE_CHALLAN", label: "Challan" } : null,
            { key: "TRNS__PUR__PURCHASE", label: "Invoice" },
            modules.purchaseReturnChallan?.enabled ? { key: "TRNS__PUR__PURCHASE_RETURN_CHALLAN", label: "Return Goods Challan" } : null,
            { key: "TRNS__PUR__PURCHASE_RETURN", label: "Return Goods" },
            { key: "TRNS__PUR__CREDIT_NOTE", label: "Credit Note" },
            { key: "TRNS__PUR__DEBIT_NOTE", label: "Debit Note" },
            { key: "TRNS__PUR__GENERAL_PURCHASE", label: "General Purchase" },
            modules.quickPurchase?.enabled ? { key: "TRNS__PUR__QUICK_PURCHASE", label: "Quick Purchase" } : null,
          ],
        },
        {
          key: "TRNS__PAYMENTS",
          label: "Bank / Cash",
          children: [
            { key: "TRNS__PAYMENTS__RECEIPT", label: "Receipt Entry" },
            { key: "TRNS__PAYMENTS__PAYMENT", label: "Payment Entry" },
            { key: "TRNS__PAYMENTS__CHEQUE_RETURN", label: "Cheque Return Entry" },
            { key: "TRNS__PAYMENTS__MULTI_RECEIPT", label: "Multi Receipt Entry" },
            { key: "TRNS__PAYMENTS__MULTI_PAYMENT", label: "Multi Payment Entry" },
          ]
        },
        ["Textile", "Weaving"].includes("Weaving") && {
          key: "TRNS__MILL",
          label: "Mill",
          children: [{ key: "TRNS__MILL__ISSUE", label: "Issue" },
          { key: "TRNS__MILL__RECEIVE", label: "Receive" },
          { key: "TRNS__MILL__CUTTING", label: "Cutting" }],
        },
        modules.internalJobwork?.enabled && {
          key: "TRNS__INTERNAL_JOBWORK",
          label: "Job Work In",
          children: [
            { key: "TRNS__JOBWORK__INWARD", label: "Job Inward" },
            modules.internalJobwork.enable3StepCycle ? { key: "TRNS__JOBWORK__OUTWARD", label: "Job Outward" } : null
          ].filter(el => el),
        },
        modules.externalJobwork?.enabled && {
          key: "TRNS__EXTERNAL_JOBWORK",
          label: "Job Work Out",
          children: [
            { key: "TRNS__JOBWORK__ISSUE", label: "Issue" },
            modules.externalJobwork.enable3StepCycle ? { key: "TRNS__JOBWORK__RECEIVE_CHALLAN", label: "Receive" } : null,
            { key: "TRNS__JOBWORK__RECEIVE", label: "Bill" },
          ].filter(el => el)
        },
        {
          key: "TRNS__JOURNAL",
          label: "Journal",
          children: [
            { key: "TRNS__JOURNAL__JOURNAL", label: "Journal Entry" },
            { key: "TRNS__JOURNAL__CONTRA", label: "Credit Transfer Entry" },
            { key: "TRNS__JOURNAL__MULTI_JOURNAL", label: "Multi Journal Entry" },
          ],
        },
        {
          key: "TRNS__STK", label: "Stock",
          children: [
            { key: "TRNS__STK__INWARD", label: "Stock Inward" },
            { key: "TRNS__STK__OUTWARD", label: "Stock Outward" },
            { key: "TRNS__STK__MOVEMENT", label: "Stock Movement" },
            { key: "TRNS__OTHER__AUTO_STOCK_MOVEMENT", label: "Auto Stock Movement Entry" },
            { key: "TRNS__STK__ASSEMBLY", label: "Stock Assembly" },
          ]
        },
        {
          key: "TRNS__COURIER", label: "Courier",
          children: [
            { key: "TRNS__COURIER__ENTRY", label: "Dispatch Entry" },
            { key: "TRNS__COURIER__BULK_ENTRY", label: "Bulk Dispatch" },
          ]
        },
        {
          key: "TRNS__PENDING",
          label: "Pending Data",
          children: [
            { key: "TRNS__PENDING__LR", label: "Pending LR" },
            ["Textile", "Weaving"].includes(industry) && {
              key: "TRNS__PENDING__LOTNO", label: "Pending Lotno"
            },
            {
              key: "TRNS__PENDING__EINVOICES", label: "Pending E-Invoices"
            },
            {
              key: "TRNS__PENDING__EWAYBILLS", label: "Pending E-Way Bills"
            },
            {
              key: "TRNS__PENDING__AMT_RECON", label: "Pending Amt Recon"
            },
            { key: "TRNS__PENDING__SERIES", label: "Missing Series" },
          ]
        },
        {
          key: "TRNS__OTHER",
          label: "Other",
          children: [
            { key: "TRNS__OTHER__COMM_STATUS", label: "Comm Status Entry" },
            { key: "TRNS__OTHER__MULTI_ENTRY", label: "Multi Journal / Payment" },
          ]
        }
      ]
    },
    {
      key: "REPORTS",
      label: "Reports",
      icon: < BarChartOutlined />,
      children: [
        industry === "Agency" && {
          key: "REPORTS__AGENCY",
          label: "Agency",
          children: [
            (userOrgRole === userOrgRoles.OWNER || reportPermissions.agencyOutstanding)
              ? { key: "REPORTS__AGENCY__OUTSTANDING", label: "Outstanding" } : null,
            ((userOrgRole === userOrgRoles.OWNER || reportPermissions.agencyCommission) && orgSettings?.recon_apym_in_rcp)
              ? { key: "REPORTS__AGENCY__COMMISSION", label: "Commission" } : null,
            (userOrgRole === userOrgRoles.OWNER || reportPermissions.agencyPurchase)
              ? { key: "REPORTS__AGENCY__DISPATCH", label: "Dispatch" } : null,
            (userOrgRole === userOrgRoles.OWNER || reportPermissions.agencyPurchase)
              ? { key: "REPORTS__AGENCY__PURCHASE", label: "Purchase" } : null,
            (userOrgRole === userOrgRoles.OWNER || reportPermissions.agencyOrder)
              ? { key: "REPORTS__AGENCY__ORDER", label: "Orders" } : null,
            (userOrgRole === userOrgRoles.OWNER || reportPermissions.agencyPayment)
              ? { key: "REPORTS__AGENCY__PAYMENT", label: "Payment List" } : null,
            (userOrgRole === userOrgRoles.OWNER || userOrgPermissions.transactions.APYM?.read)
              ? { key: "REPORTS__AGENCY__UNBILLED_VOUCHERS", label: "Unbilled Vouchers" } : null,
            (userOrgRole === userOrgRoles.OWNER || reportPermissions.agencyOutstanding) ? {
              key: "REPORTS__TRNS_INTEREST", label: "Late Payment Interest", state: { mode: "Agency" }
            } : null,
            (userOrgRole === userOrgRoles.OWNER || reportPermissions.ledger) ? {
              key: "REPORTS__AGENCY__ANALYSIS", label: "Analysis"
            } : null,
          ]
        },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.ledger) && {
          key: "REPORTS__LEDGER",
          label: "Ledger",
          children: [
            { key: "REPORTS__LEDGER__LEDGER", label: "Ledger" },
            { key: "REPORTS__LEDGER__MULTI_LEDGER", label: "Multi Ledger" },
            { key: "REPORTS__ACCOUNT_GROUP__BALANCE", label: "Group Balance" },
            { key: "REPORTS__LEDGER_INTEREST", label: "Ledger Interest" },
            { key: "REPORTS__DEPRECIATION", label: "Depreciation" },
            { key: "REPORTS__LEDGER_OUTSTANDING_MISMATCH", label: "Outstanding Mismatch" },
          ]
        },
        (salesOutstandingAccess || purchaseOutstandingAccess) && {
          key: "REPORTS__OUTSTANDING",
          label: "Outstanding",
          children: [
            salesOutstandingAccess ? { key: "REPORTS__OUTSTANDING__SAL", label: "Sales" } : null,
            purchaseOutstandingAccess ? { key: "REPORTS__OUTSTANDING__PUR", label: "Purchase" } : null,
            (salesOutstandingAccess || purchaseOutstandingAccess) ? {
              key: "REPORTS__TRNS_INTEREST", label: "Late Payment Interest", state: { mode: "Trading" }
            } : null,
            salesOutstandingAccess ? { key: "REPORTS__OUTSTANDING_90DAYS__SAL", label: "Sales Ageing" } : null,
            purchaseOutstandingAccess ? { key: "REPORTS__OUTSTANDING_90DAYS__PUR", label: "Purchase Ageing" } : null,
          ]
        },
        (salesBrokerageAccess || purchaseBrokerageAccess) && {
          key: "REPORTS__BROKERAGE", label: "Brokerage",
          children: [
            salesBrokerageAccess && {
              key: "REPORTS__BROKERAGE__SAL",
              label: "Sales Brokerage",
            },
            purchaseBrokerageAccess && {
              key: "REPORTS__BROKERAGE__PUR",
              label: "Purchase Brokerage",
            }
          ].filter(el => el)
        },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.bank) && {
          key: "REPORTS__BANK",
          label: "Bank",
          children: [
            { key: "REPORTS__BANK__SLIP", label: "Bank Slip" },
            { key: "REPORTS__BANK__RECON", label: "Manual Bank Reco" },
            { key: "REPORTS__BANK__AUTO_BRS", label: "Auto Bank Reco" },
            { key: "REPORTS__BANK__STATEMENT", label: "Bank Statement (as per Clearing)" },
            { key: "REPORTS__BANK__INTEREST", label: "Bank CC/OD Interest" },
          ]
        },
        (salesOrderReportAccess || purchaseOrderReportAccess) && {
          key: "REPORTS__ORDER", label: "Order Form",
          children: [
            salesOrderReportAccess && {
              key: "REPORTS__ORDER__SLO",
              label: "Sale Order",
            },
            purchaseOrderReportAccess && {
              key: "REPORTS__ORDER__PUO",
              label: "Purchase Order",
            }
          ].filter(el => el)
        },
        (
          modules.salesChallan?.enabled
          || modules.salesReturnChallan?.enabled
          || modules.purchaseChallan?.enabled
          || modules.purchaseReturnChallan?.enabled
        ) && {
          key: "REPORTS__UNBILLED_CHALLAN", label: "Unbilled Challans",
          children: [
            modules.salesChallan?.enabled && {
              key: "REPORTS__UNBILLED_CHALLAN__SLC",
              label: "Sale Challan",
            },
            modules.salesReturnChallan?.enabled && {
              key: "REPORTS__UNBILLED_CHALLAN__RSLC",
              label: "Sale Return Challan",
            },
            modules.purchaseChallan?.enabled && {
              key: "REPORTS__UNBILLED_CHALLAN__PRC",
              label: "Purchase Challan",
            },
            modules.purchaseReturnChallan?.enabled && {
              key: "REPORTS__UNBILLED_CHALLAN__RPUC",
              label: "Purchase Return Challan",
            },
          ].filter(el => el)
        },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.sales) && {
          key: "REPORTS__SALES",
          label: "Sales",
          children: [
            {
              key: "REPORTS__SALES__SAL",
              label: "Sales Invoice",
              children: [
                { key: "REPORTS__SALES__REGISTER", label: "Register" },
                { key: "REPORTS__SALES__SUMMARY", label: "Summary" },
              ]
            },
            {
              key: "REPORTS__SALES__RSL",
              label: "Sales Return",
              children: [
                { key: "REPORTS__SALES_RETURN__REGISTER", label: "Register" },
                { key: "REPORTS__SALES_RETURN__SUMMARY", label: "Summary" },
              ]
            },
            {
              key: "REPORTS__SALES__SDN",
              label: "Sales Debit Note",
              children: [
                { key: "REPORTS__SALES_DEBIT_NOTE__REGISTER", label: "Register" },
                { key: "REPORTS__SALES_DEBIT_NOTE__SUMMARY", label: "Summary" },
              ]
            },
            {
              key: "REPORTS__SALES__SCN",
              label: "Sales Credit Note",
              children: [
                { key: "REPORTS__SALES_CREDIT_NOTE__REGISTER", label: "Register" },
                { key: "REPORTS__SALES_CREDIT_NOTE__SUMMARY", label: "Summary" },
              ]
            },
            {
              key: "REPORTS__SALES__ALL",
              label: "Net Sales (All)",
              children: [
                { key: "REPORTS__NET_SALES__REGISTER", label: "Register" },
                { key: "REPORTS__NET_SALES__SUMMARY", label: "Summary" },
              ]
            }
          ]
        },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.purchase) && {
          key: "REPORTS__PUR",
          label: "Purchase",
          children: [
            {
              key: "REPORTS__PURCHASE__PUR",
              label: "Purchase Invoice",
              children: [
                { key: "REPORTS__PURCHASE__REGISTER", label: "Register" },
                { key: "REPORTS__PURCHASE__SUMMARY", label: "Summary" },
              ]
            },
            {
              key: "REPORTS__PURCHASE__RPU",
              label: "Purchase Return",
              children: [
                { key: "REPORTS__PURCHASE_RETURN__REGISTER", label: "Register" },
                { key: "REPORTS__PURCHASE_RETURN__SUMMARY", label: "Summary" },
              ]
            },
            {
              key: "REPORTS__PUR__PDN",
              label: "Purchase Debit Note",
              children: [
                { key: "REPORTS__PURCHASE_DEDIT_NOTE__REGISTER", label: "Register" },
                { key: "REPORTS__PURCHASE_DEDIT_NOTE__SUMMARY", label: "Summary" },
              ]
            },
            {
              key: "REPORTS__PUR__PCN",
              label: "Purchase Credit Note",
              children: [
                { key: "REPORTS__PURCHASE_CREDIT_NOTE__REGISTER", label: "Register" },
                { key: "REPORTS__PURCHASE_CREDIT_NOTE__SUMMARY", label: "Summary" },
              ]
            },
            {
              key: "REPORTS__PUR__NET_PURCHASE",
              label: "Net Purchase (All)",
              children: [
                { key: "REPORTS__NET_PURCHASE__REGISTER", label: "Register" },
                { key: "REPORTS__NET_PURCHASE__SUMMARY", label: "Summary" },
              ]
            }
          ]
        },
        {
          key: "REPORTS__TRN",
          label: "Transaction",
          children: [
            { key: "REPORTS__TRN__REGISTER", label: "Register" },
            { key: "REPORTS__TRN__SUMMARY", label: "Summary" },
            { key: "REPORTS__TRN__ANALYSIS", label: "Analysis" },
          ]
        },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.gstr) && {
          key: "REPORTS__GSTR",
          label: "GSTR",
          children: [
            { key: "REPORTS__GSTR__1", label: "GSTR 1" },
            { key: "REPORTS__GSTR__2A", label: "GSTR 2A" },
            { key: "REPORTS__GSTR__2B", label: "GSTR 2B Recon" },
            { key: "REPORTS__GSTR__3B", label: "GSTR 3B" },
            { key: "REPORTS__GSTR__9", label: "GSTR 9" },
          ],
        },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.tds) && {
          key: "REPORTS__TDS",
          label: "TDS/TCS",
          children: [
            { key: "REPORTS__TDS__CREATE_CHALLAN", label: "Create Challan" },
            { key: "REPORTS__TDS__CHALLAN_HISTORY", label: "Challan History" },
            { key: "REPORTS__TDS__SUMMARY", label: "TDS Summary" },
            { key: "REPORTS__TDS__REGISTER", label: "TDS Register" },
            { key: "REPORTS__TDS__94Q", label: "94Q Report" },
            { key: "REPORTS__TCS__SUMMARY", label: "TCS Summary" },
            { key: "REPORTS__TCS__REGISTER", label: "TCS Register" },
            { key: "REPORTS__TDS__RETURN_FILING", label: "Return Filing" },
          ],
        },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.final) && {
          key: "REPORTS__FINAL",
          label: "Final Reports",
          children: [
            { key: "REPORTS__FINAL__TRIAL_BALANCE", label: "Trial Balance" },
            { key: "REPORTS__FINAL__TRIAL_BALANCE_OPENING", label: "Opening Trial Balance" },
            { key: "REPORTS__FINAL__PNL", label: "Trading and P&L" },
            { key: "REPORTS__FINAL__BALANCE_SHEET", label: "Balance Sheet" },
            { key: "REPORTS__FINAL__FINAL_LEDGER", label: "Final Ledger" },
          ],
        },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.final) && {
          key: "REPORTS__AUDIT",
          label: "Audit Reports",
          children: [
            { key: "REPORTS__AUDIT__ANNEXURE44", label: "Annexure 44" },
            { key: "REPORTS__AUDIT__GP_STOCK_ANALYSIS", label: "GP Stock Analysis" },
            { key: "REPORTS__AUDIT__AUDIT_LOG", label: "Audit Log" },
            { key: "REPORTS__AUDIT__USER_PERMISSIONS", label: "User Permissions" },
          ],
        },
      ]
    },
    industry !== "Agency" && {
      key: "STK_REPORTS",
      label: "Stock Reports",
      icon: <ProductOutlined />,
      children: [
        ["Textile", "Weaving"].includes(industry) && (userOrgRole === userOrgRoles.OWNER || reportPermissions.mill) && {
          key: "STK_REPORTS__MILL",
          label: "Mill",
          children: [
            { key: "STK_REPORTS__MILL__PENDING", label: "Mill Pending" },
            { key: "STK_REPORTS__MILL__RECEIVE", label: "Mill Receive" },
            { key: "STK_REPORTS__MILL__SHORTAGE", label: "Mill Shortage" },
          ]
        },
        modules.internalJobwork?.enabled && (userOrgRole === userOrgRoles.OWNER || reportPermissions.internalJob) && {
          key: "STK_REPORTS__INTERNAL_JOB",
          label: "Job Work In",
          children: [
            { key: "STK_REPORTS__JOB__JOB_AT_IN", label: "Job In Pending" },
            { key: "STK_REPORTS__JOB__JOB_OUTWARD", label: "Job Outward" },
          ],
        },
        modules.externalJobwork?.enabled && (userOrgRole === userOrgRoles.OWNER || reportPermissions.externalJob) && {
          key: "STK_REPORTS__EXTERNAL_JOB",
          label: "Job Work Out",
          children: [
            { key: "STK_REPORTS__JOB__JOB_AT_OUT", label: "Job Out Pending" },
            { key: "STK_REPORTS__JOB__JOB_RECEIVE", label: "Job Receive" },
            { key: "STK_REPORTS__JOB__INWARD_WITH_MOVEMENT", label: "Inward With Movement" }
          ]
        },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.stock) && { key: "STK_REPORTS__RAW_AT_SHOP", label: `${rawSectionName} At Shop` },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.stock) && { key: "STK_REPORTS__FINISH_AT_SHOP", label: "Finish At Shop" },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.stock) && { key: "STK_REPORTS__BALANCE", label: "Stock Balance" },
        (userOrgRole === userOrgRoles.OWNER || reportPermissions.stock) && { key: "STK_REPORTS__SUMMARY", label: "Stock Summary" },
      ]
    },
    (userOrgRole === userOrgRoles.OWNER || userOrgPermissions.settings?.update) && {
      key: "SETTINGS",
      label: "Settings",
      icon: < SettingOutlined />,
      children: [
        { key: "SETTINGS__PROFILE", label: "Profile" },
        { key: "SETTINGS__USERS", label: "Users & Roles" },
        {
          key: "SETTINGS__SETUP",
          label: "Setup",
          children: [
            { key: "SETTINGS__SETUP__PREFERENCES", label: "Preferences" },
            { key: "SETTINGS__SETUP__EXPENSES", label: "Expenses" },
            { key: "SETTINGS__SETUP__DATA_ENTRY", label: "Data Entry" },
            { key: "SETTINGS__SETUP__REPORT_FORMATS", label: "Report Formats" },
            { key: "SETTINGS__SETUP__VOUCHER_TEMPLATE", label: "Voucher Template" },
            { key: "SETTINGS__SETUP__WHATSAPP", label: "Whatsapp" },
            { key: "SETTINGS__SETUP__EMAIL", label: "Email" },
            { key: "SETTINGS__SETUP__AUTOMATIONS", label: "Automations" },
            { key: "SETTINGS__SETUP__CUSTOM_FIELDS", label: "Custom Fields" },
            { key: "SETTINGS__SETUP__COSTING_EXPENSES", label: "Costing Expenses" },
            { key: "SETTINGS__SETUP__CSV_EXPORT_FORMATS", label: "CSV Export Formats" },
            { key: "SETTINGS__SETUP__CSV_IMPORT_FORMATS", label: "CSV Import Formats" },
          ],
        },
        {
          key: "SETTINGS__IMPORT",
          label: "Import Data",
          children: [
            { key: "SETTINGS__IMPORT__ACM", label: "Accounts" },
            { key: "SETTINGS__IMPORT__BALANCES", label: "Account Balances" },
            { key: "SETTINGS__IMPORT__UPDATE_BALANCES", label: "Update Account Balances Manually" },
            { key: "SETTINGS__IMPORT__ITM", label: "Products" },
            { key: "SETTINGS__IMPORT__ITS", label: "Designs" },
            { key: "SETTINGS__IMPORT__HSN", label: "HSN Codes" },
            { key: "SETTINGS__IMPORT__STK", label: "Stock Inward" },
            industry === "Agency" && { key: "SETTINGS__IMPORT__APUR", label: "Agency Purchase" },
            industry === "Agency" && { key: "SETTINGS__IMPORT__ARPU", label: "Agency Return Goods" },
            industry === "Agency" && { key: "SETTINGS__IMPORT__APYM", label: "Agency Payments" },
            {
              key: "SETTINGS__IMPORT__SALES",
              label: "Sales",
              children: [
                { key: "SETTINGS__IMPORT__QSAL", label: "Sales" },
                { key: "SETTINGS__IMPORT__RSL", label: "Sales Return" },
                { key: "SETTINGS__IMPORT__SCN", label: "Sales Credit Note" },
                { key: "SETTINGS__IMPORT__SDN", label: "Sales Debit Note" },
              ]
            },
            {
              key: "SETTINGS__IMPORT__PURCHASE",
              label: "Purchase",
              children: [
                { key: "SETTINGS__IMPORT__QPUR", label: "Purchase" },
                { key: "SETTINGS__IMPORT__RPU", label: "Purchase Return" },
                { key: "SETTINGS__IMPORT__PDN", label: "Purchase Debit Note" },
                { key: "SETTINGS__IMPORT__PCN", label: "Purchase Credit Note" },
              ]
            },
            {
              key: "SETTINGS__IMPORT__BANK_CASH",
              label: "Bank / Cash",
              children: [
                { key: "SETTINGS__IMPORT__RCP", label: "Receipt Entry" },
                { key: "SETTINGS__IMPORT__PYM", label: "Payment Entry" },
              ]
            },
            {
              key: "SETTINGS__IMPORT__BRC",
              label: "Bank Reconciliation Entry",
              children: [
                { key: "SETTINGS__IMPORT__BRCR", label: "Bank Reconciliation Receipt" },
                { key: "SETTINGS__IMPORT__BRCP", label: "Bank Reconciliation Payment" },
              ]
            },
            { key: "SETTINGS__IMPORT__GIS", label: "Mill Challans" },
            { key: "SETTINGS__IMPORT__JIS", label: "Job Challans" },
            industry === "Jobwork" && { key: "SETTINGS__IMPORT__JIN", label: "Job Inward" },
            { key: "SETTINGS__IMPORT__TRNS", label: "Current Year Transactions" },
            {
              key: "SETTINGS__IMPORT__UTILITIES",
              label: "Utilities",
              children: [
                { key: "SETTINGS__IMPORT__UTILITIES__DATA_TRANSFER", label: "Extract From Backup" },
                { key: "SETTINGS__IMPORT__UTILITIES__TEXT_TO_EXCEL", label: "Text To Excel" },
                { key: "SETTINGS__IMPORT__UTILITIES__TRANSFORM_OUTSTANDING", label: "Transform Outstanding" },
              ]
            },
          ]
        },
        {
          key: "SETTINGS__UTILITIES",
          label: "Utilities",
          children: [
            { key: "SETTINGS__UTILITIES__MERGE_MASTERS", label: "Merge masters" },
            { key: "SETTINGS__UTILITIES__UPDATE_BROKER", label: "Update broker" },
            { key: "SETTINGS__UTILITIES__UPDATE_CUT", label: "Update cut" },
            { key: "SETTINGS__UTILITIES__UPDATE_WASTAGE", label: "Update auto cutting wastage" },
            { key: "SETTINGS__UTILITIES__REINDEX_VOUCHERS", label: "Re arrange voucher numbers" },
            { key: "SETTINGS__UTILITIES__RESAVE_TRANSACTIONS", label: "Resave transactions" },
          ],
        },
        { key: "SETTINGS__FCYEARS", label: "FC Years" },
        { key: "SETTINGS__BACKUP", label: "Backup" },
        { key: "SETTINGS__DATA_LOCKING", label: "Data Locking" },
        { key: "SETTINGS__YEAREND", label: "Year Closing" },
      ]
    }
  ];

  return { menuItems, menuTree };
};


export default () => {
  const [openKeys, setOpenKeys] = useState([]);
  const triggerElementRef = useRef();

  const onSelect = ({ key, item }) => {
    const menuItem = menuItems[key];
    setTimeout(() => {
      setOpenKeys([]);
      triggerElementRef.current?.focus();
      if (menuItem && menuItem.path) {
        addAppTab(menuItem.path, menuItem.title, item?.props?.state ?? menuItem.state);
      }
    });
  };

  const { menuItems, menuTree } = useSideNavMenu();

  // Work around to fix ant design menu bug of menu popup getting cut from top
  useEffect(() => {
    setTimeout(() => {
      const subMenuPopups = document.getElementsByClassName("ant-menu-submenu-popup");
      Array.from(subMenuPopups).forEach(obj => {
        if (obj.offsetTop < 0) {
          obj.style.top = "0px";
        }
      })
    }, 10)
  }, [openKeys])

  useMouseTrap(
    { current: document.body },
    {
      "alt+n": () => {
        triggerElementRef.current = document.activeElement;
        document.body.querySelector(".ant-layout-sider div[role='menuitem']").focus();
      },
    }
  );

  return (
    <Menu
      style={{ background: "#19185f", color: "white", paddingBottom: 48 }}
      theme="dark"
      mode="vertical"
      triggerSubMenuAction="click"
      onSelect={onSelect}
      onOpenChange={(keys) => {
        const lastKey = keys[keys.length - 1];
        setOpenKeys(keys.filter(key => lastKey.includes(key)));
      }}
      selectedKeys={[]}
      openKeys={openKeys}
      items={menuTree}
    />
  )
}